<template>
  <v-row justify="center">
    <v-dialog
      style="border-radius: 5px"
      v-model="show"
      persistent
      max-width="600px"
    >
      <custom-modal
        title="Edit Event Type "
        @onSubmit="SaveEventType"
        @onClose="close"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="6" sm="6" lg="6">
              <ValidationProvider
                rules="required"
                name="Name"
                vid="name"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="EventType.name"
                  label="Name"
                  auto-grow
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" sm="6" lg="6">
              <ValidationProvider
                rules="required"
                name="code"
                vid="code"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="EventType.code"
                  label="Code"
                  auto-grow
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" lg="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="color"
                rules="required"
                hide-details="auto"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn :color="EventType.color" dark v-on="on">
                      Event Type Color
                    </v-btn>
                  </template>
                  <v-color-picker
                    value="#7417BE"
                    v-model="EventType.color"
                    hide-canvas
                    hide-inputs
                    show-swatches
                    class="mx-auto"
                  ></v-color-picker>
                </v-menu>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" sm="6" lg="6">
              <v-text-field
                :error-messages="errors"
                v-model="EventType.icon"
                label="Icon"
                auto-grow
                outlined
                hide-details="auto"
              ></v-text-field>

              <a
                target="_blank"
                href="https://pictogrammers.github.io/@mdi/font/5.0.45/"
                >https://pictogrammers.github.io/@mdi/font/5.0.45/</a
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" lg="6">
              <ValidationProvider rules="required" name="Read Only">
                <v-select
                  hide-details="auto"
                  dense
                  slot-scope="{ errors }"
                  v-model="EventType.readonly"
                  item-text="name"
                  item-value="name"
                  :items="question"
                  :error-messages="errors"
                  label="Read Only"
                  outlined
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" sm="6" lg="6">
              <ValidationProvider rules="required" name="Is Holiday">
                <v-select
                  hide-details="auto"
                  dense
                  slot-scope="{ errors }"
                  v-model="EventType.is_holiday"
                  item-text="name"
                  item-value="name"
                  :items="question"
                  :error-messages="errors"
                  label="Is Holiday"
                  outlined
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <ValidationProvider
                name="Description"
                rules="required"
                v-slot="{ errors }"
                hide-details="auto"
              >
                <v-textarea
                  hide-details="auto"
                  :error-messages="errors"
                  required
                  label="
                      Description"
                  v-model="EventType.description"
                  outlined
                  rows="3"
                ></v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from '@/plugins/axios';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import CustomModal from '@/components/base/CustomModal';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

export default {
  data: () => ({
    dialog: false,
    expenseLoading: false,
    question: [{ name: 'Yes' }, { name: 'No' }],
    value: [],

    options: [],
    isLoading: false,
  }),

  name: 'EventType',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    EventType: {
      type: Object,
      default: {},
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,

    CustomModal,
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close', this.EventType);
        }
      },
    },
  },
  methods: {
    close() {
      this.show = false;
      this.EventType = new EventType();

      this.$refs.observer.reset();
    },
    async SaveEventType() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.EditEventType();
      }
    },

    EditEventType() {
      this.isLoading = true;

      const credential = { ...this.EventType }; // Deep clone preferred
      const eventid = credential.id;

      // Remove unnecessary fields
      delete credential.id;
      delete credential.created_at;
      delete credential.deleted_at;
      delete credential.updated_at;
      delete credential.is_active;

      axios
        .patch(`event-type/${eventid}`, credential)
        .then((res) => {
          this.succeeed = true;
          this.$emit('afterSave');
          this.$toast.success('Event type edited successfully');

          this.show = false;
          this.$refs.observer.reset();
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.error) {
            this.$refs.observer.setErrors(err.response.data.error);
          }

          this.$toast.error(
            err.response?.data?.title || 'Failed to edit event type.',
          );
          this.messages = err.response?.data?.title || '';
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
